var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatH1I = function SvgChatH1I(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M15.849 16a.42.42 0 0 1-.423-.418v-2.555l-.616.621a.426.426 0 0 1-.6 0 .4.4 0 0 1 0-.585l1.34-1.313a.44.44 0 0 1 .471-.107.42.42 0 0 1 .254.382v3.557a.41.41 0 0 1-.426.418m-3.815 0a.425.425 0 0 1-.423-.418v-3.164H8.545v3.164a.425.425 0 0 1-.422.418.425.425 0 0 1-.423-.418V8.418A.425.425 0 0 1 8.123 8a.425.425 0 0 1 .422.418v3.164h3.066V8.418a.423.423 0 0 1 .845 0v7.164a.425.425 0 0 1-.422.418"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatH1I);
export default ForwardRef;